import "./styles/main.css";
import { registerSW } from "virtual:pwa-register";
import { boot } from "./boot.js";

boot(registerSW);
